import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import COLORS from '@mlb/react-patterns/style/universal.color';
import Button from '@mlb/react-patterns/components/Button/button.tsx';
import PopoverPattern from '@mlb/react-patterns/components/Popover/popover.tsx';
import { IconWrapper } from '@mlb/react-patterns/components/Icon/icon.style.tsx';

import { Tracking } from 'bdvp-tracking';

const Popover = styled(PopoverPattern)`
    && {
        pointer-events: all;
        background: ${COLORS.mlbWhite};
        border: none;
    }
`;

export const ClipMenuButton = styled(Button)`
    pointer-events: ${({ disabled }) => disabled ? 'none' : 'all'};
    outline-offset: -2px;
    height: 100%;
    border-radius: 0px;
    border-bottom-right-radius: 8px;
    ${IconWrapper} {
        stroke: none;
        padding-top: 0;
    }
`;

const backdropProps = {
    style: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    'data-click-handler': true,
};

const OptionsMenu = forwardRef(({
    orientation,
    onPopoverOpen,
    onPopoverClose,
    disabled,
    altText,
    optionsMenuContent,
    preventOverflow,
    preventOverflowPadding,
    popoverPlacement,
    popoverOffset,
    showArrow,
}, ref) => {

    return (
        <Popover
            portalTarget={typeof window !== 'undefined' && document.body}
            showMultiple={false}
            orientation={orientation}
            onOpen={onPopoverOpen}
            onClose={onPopoverClose}
            popoverOffset={popoverOffset}
            popoverContent={optionsMenuContent}
            placement={popoverPlacement}
            preventOverflow={preventOverflow}
            preventOverflowPadding={preventOverflowPadding}
            flipPopover={preventOverflow}
            showArrow={showArrow}
            enableBackdropClick
            enableScrollbarWidthOffset
            enableScrollLock
            enableBackdrop
            backdropProps={backdropProps}
        >
            <ClipMenuButton
                ref={ref}
                disabled={disabled}
                orientation={orientation}
                iconName={'dot-menu'}
                size={'md'}
                styleName={'default'}
                shape={'hollow-borderless'}
                hasHover={false}
                additionalProps={{
                    'aria-label': altText,
                }}
                dataAttr={{
                    'data-click-handler': true,
                }}
                handlers={
                    {
                        onClick: () => Tracking.trackClipMenuClick(),
                    }
                }
            />
        </Popover>
    );

});

OptionsMenu.propTypes = {
    orientation: PropTypes.string.isRequired,
    onPopoverOpen: PropTypes.func.isRequired,
    onPopoverClose: PropTypes.func.isRequired,
    altText: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    optionsMenuContent: PropTypes.node,
    preventOverflow: PropTypes.bool,
    popoverPlacement: PropTypes.string,
    popoverOffset: PropTypes.array,
    showArrow: PropTypes.bool,
};

OptionsMenu.defaultProps = {
    disabled: false,
    optionsMenuContent: undefined,
    preventOverflow: true,
    popoverPlacement: 'bottom-end',
    popoverOffset: [
        0,
        0,
    ],
    showArrow: false,
};

export default OptionsMenu;
